import Yup from '@tmh-website/services/validation.service';
import type { TFunction } from 'i18next';

export type IssueTypeOption = {
  label: string;
  value: 'Charging sessions / Load management' | 'Hardware defect / Error message' | 'Something else';
};

export type SupportForEvDriversWeb2CaseFormValues = {
  who: string;
  first_name: string;
  last_name: string;
  postal_code: string;
  street: string;
  city: string;
  phone: string;
  email: string;
  issue_type?: IssueTypeOption['label'];
  nachricht?: string;
  serial_number?: string;
  'g-recaptcha-response': string;
};

export const validaitonSchema = (t: TFunction<'translation', undefined>) =>
  new Yup.ObjectSchema({
    first_name: Yup.string().required(t('validation:mixed.required')),
    last_name: Yup.string().required(t('validation:mixed.required')),
    postal_code: Yup.string().required(t('validation:mixed.required')),
    street: Yup.string().required(t('validation:mixed.required')),
    city: Yup.string().required(t('validation:mixed.required')),
    phone: Yup.string()
      .matches(/^(\+?[0-9]+)$/)
      .required(t('validation:mixed.required')),
    email: Yup.string().email(t('validation:string.email')).required(t('validation:mixed.required')),
    issue_type: Yup.mixed<IssueTypeOption['value']>().required(t('validation:mixed.required')),
    nachricht: Yup.string().when('issue_type', {
      is: (value: string) => value === 'Charging sessions / Load management' || value === 'etwas_anderes',
      then: Yup.string().required(t('validation:mixed.required')),
      otherwise: Yup.string().optional(),
    }),
    serial_number: Yup.string().when('issue_type', {
      is: 'Hardware defect / Error message',
      then: Yup.string().required(t('validation:mixed.required')),
      otherwise: Yup.string().optional(),
    }),
    'g-recaptcha-response': Yup.string().required(t('validation:mixed.required')),
  });
